module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/muehldorf_03-5ff7cc1d7d225904e0166682863590cb.jpg";